export default __webpack_public_path__ + "maps-guides-markers-annotations-view-960-8eecc5e3ff2cea8c57b475628715e266.webp";